import { TABLE_ALIGN } from '../components/DashboardTable';
import { DASHBOARD_COLORS } from '../styles/colors';
import { formatCellValue } from '../utils/formatters';

export const RECENT_CHALLANS_COLUMNS = [
  { key: 'index', header: 'SR.No', align: TABLE_ALIGN.CENTER },
  {
    key: 'challanNo',
    header: 'Challan No',
    align: TABLE_ALIGN.CENTER,
    mono: true,
    color: DASHBOARD_COLORS.blue,
  },
  { key: 'challanDate', header: 'Challan Date', align: TABLE_ALIGN.CENTER },
  {
    key: 'status',
    header: 'Status',
    align: TABLE_ALIGN.CENTER,
    type: 'status',
  },
  {
    key: 'driver',
    header: 'Driver',
    align: TABLE_ALIGN.LEFT,
    getStyle: (row) =>
      row.driverHighlight === 'red' ? { color: DASHBOARD_COLORS.red } : undefined,
  },
  {
    key: 'amount',
    header: 'Amount',
    align: TABLE_ALIGN.RIGHT,
    type: 'amount',
    mono: true,
    color: DASHBOARD_COLORS.green,
  },
];

export const DRIVER_UTILIZATION_COLUMNS = [
  { key: 'index', header: 'SR.No', align: TABLE_ALIGN.CENTER },
  {
    key: 'name',
    header: 'Driver',
    align: TABLE_ALIGN.LEFT,
    bold: true,
  },
  { key: 'assigned', header: 'Assigned', align: TABLE_ALIGN.RIGHT },
  {
    key: 'active',
    header: 'Active',
    align: TABLE_ALIGN.RIGHT,
    render: (row) => formatCellValue(row.active),
    getStyle: (row) =>
      row.active != null
        ? { color: DASHBOARD_COLORS.blue, fontWeight: 600 }
        : undefined,
  },
  {
    key: 'delivered',
    header: 'Delivered',
    align: TABLE_ALIGN.RIGHT,
    render: (row) => formatCellValue(row.delivered),
    getStyle: (row) =>
      row.delivered != null
        ? { color: DASHBOARD_COLORS.green, fontWeight: 600 }
        : undefined,
  },
  {
    key: 'pending',
    header: 'Pending',
    align: TABLE_ALIGN.RIGHT,
    render: (row) => formatCellValue(row.pending),
    getStyle: (row) => {
      if (row.pending == null) {
        return undefined;
      }
      return {
        color: row.pending === 0 ? DASHBOARD_COLORS.green : DASHBOARD_COLORS.amber,
        fontWeight: 600,
      };
    },
  },
  {
    key: 'status',
    header: 'Status',
    align: TABLE_ALIGN.CENTER,
    type: 'status',
  },
];

export const PENDING_TRANSFERS_COLUMNS = [
  { key: 'index', header: 'SR.No', align: TABLE_ALIGN.CENTER },
  {
    key: 'transferNo',
    header: 'Transfer No',
    align: TABLE_ALIGN.CENTER,
    mono: true,
    color: DASHBOARD_COLORS.violet,
  },
  { key: 'date', header: 'Date', align: TABLE_ALIGN.CENTER },
  {
    key: 'salesTeamName',
    header: 'Sales Team Name',
    align: TABLE_ALIGN.LEFT,
    type: 'salesTeamName',
  },
  {
    key: 'status',
    header: 'Status',
    align: TABLE_ALIGN.CENTER,
    type: 'status',
  },
  {
    key: 'productCount',
    header: 'Product Count',
    align: TABLE_ALIGN.RIGHT,
    render: (row) => formatCellValue(row.productCount),
  },
  {
    key: 'qty',
    header: 'Qty',
    align: TABLE_ALIGN.RIGHT,
    mono: true,
    color: DASHBOARD_COLORS.blue,
    render: (row) => formatCellValue(row.qty),
  },
  {
    key: 'amount',
    header: 'Amount',
    align: TABLE_ALIGN.RIGHT,
    type: 'amount',
    mono: true,
    color: DASHBOARD_COLORS.green,
  },
];

export const PENDING_SETTLEMENTS_COLUMNS = [
  { key: 'index', header: 'SR.No', align: TABLE_ALIGN.CENTER },
  {
    key: 'salesman',
    header: 'Salesman',
    align: TABLE_ALIGN.LEFT,
    bold: true,
  },
  { key: 'daysPending', header: 'Days Pending', align: TABLE_ALIGN.CENTER },
  {
    key: 'urgency',
    header: 'Urgency',
    align: TABLE_ALIGN.CENTER,
    type: 'status',
    statusKey: 'urgency',
    labelKey: 'urgencyLabel',
  },
  {
    key: 'amount',
    header: 'Amount',
    align: TABLE_ALIGN.RIGHT,
    type: 'amount',
    mono: true,
    color: DASHBOARD_COLORS.green,
  },
];
